"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiCheckboxOverrides = {
    MuiCheckbox: {
        styleOverrides: {
            root: {
                '&.Mui-checked.Mui-disabled': {
                    color: '#CAE7F8',
                },
            },
        },
    },
};
exports.default = MuiCheckboxOverrides;
//# sourceMappingURL=CheckboxOverrides.js.map